import { Bundle } from 'admin/bundle/bundle'
import { RefreshBundles } from 'admin/bundle/BundleSearchViewModel'
import { BundleStore } from 'admin/bundle/BundleStore'
import { AlertFactory, AlertState } from 'alerts/Alert'
import ModalViewModel from 'infra/ModalViewModel'
import { action, observable, makeObservable } from 'mobx'
import { task } from 'mobx-task'
import { Id } from 'types/definitions'

/**
 * View model for managing the Unarchive dialog.
 */
export default class UnarchiveBundleViewModel extends ModalViewModel {
  @observable bundle: Bundle = Bundle.none

  constructor(
    private bundleStore: BundleStore,
    private refreshBundles: RefreshBundles,
    private newAlert: AlertFactory,
  ) {
    super()
    makeObservable(this)
  }

  @action
  setBundle(bundle: Bundle) {
    this.bundle = bundle
  }

  @action
  open(bundle: Bundle) {
    this.setBundle(bundle)
    this.show()
  }

  /**
   * Unarchives the bundle.
   */
  unarchive = task.resolved(async () => {
    await this.bundleStore.unarchive(Id.assert(this.bundle.Id))

    await this.refreshBundles()

    this.newAlert()
      .withState(AlertState.Success)
      .saying('Success', 'Bundle unarchived.')
      .autoDismiss()
      .show()
    this.close()
  })
}
